import { SEARCH_FIELDS } from '@wyz/utils';
import z from 'zod';

export const baseSearchFormSchema = z.object({
  vehicleTypeGroup: z.string({
    error: 'app.purchase.search_page.required_category',
  }),
  fieldNameSearch: z.enum(SEARCH_FIELDS).nullish(),
  identifier: z
    .object({
      value: z.string(),
      label: z.string(),
    })
    .nullish(),
  rawIdentifier: z.string().nullish(),
  width: z.coerce
    .number<number>({})

    .nullish(),
  height: z.coerce
    .number<number>({})

    .nullish(),
  diameter: z.coerce
    .number<number>({})

    .nullish(),
  loadIndexes: z.array(z.coerce.number<number>({})).nullish(),
  speedIndexes: z.array(z.string()).nullish(),
  seasons: z.array(z.string()).nullish(),
  quantity: z
    .number({
      error: 'app.purchase.search_page.required_quantity',
    })
    .min(1, {
      message: 'app.common.validations.min_quantity',
    }),
  brands: z.array(z.string()).nullish(),
  includeHigherIndexes: z.boolean().nullish(),
  vehicleTypes: z.array(z.string()),
});

export const SEARCH_TYPE_ENUM = {
  DISTRIBUTION: 'DISTRIBUTION',
  QUOTE: 'QUOTE',
  REDISTRIBUTION: 'REDISTRIBUTION',
} as const;
